<ng-container *ngIf="product">
  <div class="product-desc">
    <h3 class="mb-3 font-medium uppercase text-primary-darkest">
      Product Description
    </h3>
    <div class="product-desc__detail" [innerHTML]="product.description"></div>
  </div>
  <div class="product-brochure" *ngIf="brochures.length">
    <h3 class="mb-3 font-medium uppercase text-primary-darkest">
      Product Brochure
    </h3>
    <div class="brochure my-3 space-y-3">
      <img
        class="mx-auto"
        *ngFor="let brochure of brochures"
        [src]="brochure.path"
        alt="brochure"
        loading="lazy" />
    </div>
  </div>
</ng-container>
